import { render, staticRenderFns } from "./wjFittings.vue?vue&type=template&id=309c78ea&scoped=true"
import script from "./wjFittings.vue?vue&type=script&lang=js"
export * from "./wjFittings.vue?vue&type=script&lang=js"
import style0 from "./wjFittings.vue?vue&type=style&index=0&id=309c78ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309c78ea",
  null
  
)

export default component.exports